import React from "react";
import { useLocation } from "react-router-dom";
import WarehouseProductDetailsPage from "../Products/WarehouseProductDetailsPage";

export default function InventoryProductDetailsPage() {
  const location = useLocation();

  const backTo =
    location.state?.backTo || "/admin/dashboard/inventory";

  return (
    <WarehouseProductDetailsPage
      pageTitle="INVENTORY DETAILS"
      backMode="path"
      backTo={backTo}
    />
  );
}